import styled, { css } from 'styled-components';
import { memo } from 'react';
import { Hideable } from '@regular_ui/lib/components/hideable';
import { layout, remCalc } from '@prisjakt/ui-base';
import { Speed, Direction } from '@regular_ui/lib/definitions';
import { slideHideableVariant } from '@prisjakt/customization_prisjakt/variants/hideable';
import OverlayBase from '../../../../components/overlay';

const backgroundPeekWidth = 50;

export const Overlay = memo(styled(OverlayBase)`
  && {
    /* Cover the header so e.g. the search bar on the frontpage won't peek through */
    z-index: 101;
  }
`);

export const FakeHeader = memo(styled(Hideable).attrs({
  speed: Speed.Slow,
})`
  background: ${props => props.theme.header.bg};
  height: ${layout.headerHeight.mobile.rem};
  position: fixed;
  right: 0;
  top: 0;
  width: 100vw;
  /* Needs a higher z-index than the overlay */
  z-index: 102;
`);

export const Sidebar = styled(Hideable).attrs({
  // NOTE: Casting as `any` to suppress the TS error. Should be fixed when we have time
  variant: slideHideableVariant as any,
  speed: Speed.Slow,
  styledComponentProps: {
    slideDirection: Direction.Left,
    'data-test': 'SidebarMobile',
  },
})`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  /* Override default slide transform to make the menu button line up with the one in the header */
  ${props =>
    !props.visible &&
    css`
      && {
        transform: translateX(calc(${remCalc(backgroundPeekWidth)} - 100%));
      }
    `}
  /* Needs a higher z-index than the overlay */
  z-index: 102;
`;
